<div class="waiting-offer-dialog" *ngIf="data">
    <h4 class="waiting-offer-dialog__title">
        {{data.header}}
    </h4>
    <img class="waiting-offer-dialog__image"
         [src]="data.imageSrc" alt="">
    <h3 class="waiting-offer-dialog__subtitle">
        <div *ngIf="showProgressBar; else loader" class="waiting-offer-dialog__progress-bar">
            <mat-progress-bar
                    mode="determinate"
                    [value]="progressBarValue">
            </mat-progress-bar>
            {{data.offersMessage}} {{ totalAmountOfOffers }} {{ totalAmountOfOffers | amountNounTranslation:'OFFER_SECTION' | async }}!
        </div>
        <ng-template #loader>
            {{data.offersMessage}} <div class="waiting-offer-dialog__circle">{{ totalAmountOfOffers }}<span class="loader"></span></div> {{ totalAmountOfOffers | amountNounTranslation:'OFFER_SECTION' | async }}!
        </ng-template>
    </h3>
    <p class="waiting-offer-dialog__paragraph"
       [innerHtml]="data.analysisMessage | safeHtml"></p>
    <p class="waiting-offer-dialog__paragraph">
        {{data.footer}}
    </p>
</div>
